import { extend } from 'vee-validate';
import { email } from 'vee-validate/dist/rules';

extend('email', {
    ...email,
    message: 'Please enter a valid email'
});
